export const RESOURCE_MATCH_ITEM_BUTTONS = {
  ACCEPT: 'ACCEPT',
  PROPOSE: 'PROPOSE'
};
